@if (products.length !== 0) {
  <div class="container d-flex justify-content-center align-items-center flex-column mt-xl-5 pt-xl-5">
    <h3>You may also like</h3>
    <div class="w-100 no-select">
      <swiper-container
        #swiper
        navigation="true"
        slidesPerView="4"
        scrollbar="true"
        space-between="30"
        [breakpoints]="{
          '0': {
            slidesPerView: 1,
            spaceBetween: 10
          },
          '550': {
            slidesPerView: 2,
            spaceBetween: 20
          },
          '768': {
            slidesPerView: 2,
            spaceBetween: 40
          },
          '1024': {
            slidesPerView: 3,
            spaceBetween: 50
          }
        }">
      @for (product of products; track product) {
        <swiper-slide>
          <div class="swiper-slide mt-3 mb-5">
            <app-product-card [isNew]="true" [product]="product" class="d-flex justify-content-center"></app-product-card>
          </div>
        </swiper-slide>
      }
    </swiper-container>
  </div>
</div>
}
